/** Shown when GET story/usp returns `pending: true` and the user tries to open the editor. */
export const TOAST_STORY_PENDING_REVIEW =
  'Your story update is under review. Please wait until it has been approved before making another change.';

export const TOAST_USP_PENDING_REVIEW =
  'Your USP update is under review. Please wait until it has been approved before making another change.';
